var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoReservationIcon = function SvgNoReservationIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49.607,
    height: 40.997,
    viewBox: "0 0 49.607 40.997",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5612",
    "data-name": "Grupo 5612",
    transform: "translate(-149.616 -703.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5587",
    "data-name": "Grupo 5587",
    transform: "translate(150.499 703.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_10",
    "data-name": "Subtra\\xE7\\xE3o 10",
    d: "M10.824,21.63H10.8a10.815,10.815,0,0,1,0-21.63h.018a10.815,10.815,0,0,1,7.641,18.46A10.751,10.751,0,0,1,10.824,21.63ZM9.791,5.01h0v7.007l6.132,3.68.971-1.594-5.166-3.068V5.01H9.791Z",
    transform: "translate(13.326 9.111)",
    fill: "#c1c1c1",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_15",
    "data-name": "Subtra\\xE7\\xE3o 15",
    d: "M23.909,29.681A19.967,19.967,0,0,1,3.963,9.738V8.528H0L5.106,0l5.105,8.528H6.247v1.21A17.681,17.681,0,0,0,23.907,27.4a17.511,17.511,0,0,0,10.378-3.379v2.747A19.879,19.879,0,0,1,23.909,29.681Z",
    transform: "translate(47.842 29.681) rotate(180)",
    fill: "#c1c1c1",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_16",
    "data-name": "Subtra\\xE7\\xE3o 16",
    d: "M23.909,29.681A19.967,19.967,0,0,1,3.964,9.738V8.528H0L5.107,0l5.1,8.528H6.248v1.21A17.68,17.68,0,0,0,23.908,27.4a17.511,17.511,0,0,0,10.378-3.379v2.746A19.88,19.88,0,0,1,23.909,29.681Z",
    transform: "translate(0 10.315)",
    fill: "#c1c1c1",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5614",
    "data-name": "Grupo 5614",
    transform: "translate(150.499 703.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_11",
    "data-name": "Uni\\xE3o 11",
    d: "M3.964,20.053V18.844H0l5.106-8.528,5.1,8.528H6.247v1.209a17.653,17.653,0,0,0,28.039,14.28V37.08A19.939,19.939,0,0,1,3.964,20.053ZM24.128,30.743a10.816,10.816,0,0,1,0-21.631h.018a10.816,10.816,0,0,1,0,21.631Zm-1.011-9.614,6.133,3.681.971-1.594-5.166-3.07V14.122H23.116Zm14.515.025h3.963V19.943A17.654,17.654,0,0,0,13.556,5.663V2.917A19.939,19.939,0,0,1,43.878,19.943v1.211h3.964l-5.106,8.527Z",
    transform: "translate(0 0)",
    fill: "#c1c1c1",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoReservationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-reservation-icon.60e59858.svg";
export { ForwardRef as ReactComponent };